/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Duplicate_ColumnInputs */

const en_issue_duplicate_column = /** @type {(inputs: Issue_Duplicate_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`column present more than once`)
};

/**
* | output |
* | --- |
* | "column present more than once" |
*
* @param {Issue_Duplicate_ColumnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_duplicate_column = /** @type {((inputs?: Issue_Duplicate_ColumnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Duplicate_ColumnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_duplicate_column(inputs)
});